import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import NewMatches from './NewMatches';
import DNAMatches from "./DNAMatches";
import ChatBox from "../inbox/components/ChatBox";

// Tab component mapping
const tabComponents = {
  matches: NewMatches,
  dnaMatches:DNAMatches,
};

// Tab headings
const tabHeadings = {
  matches: "Suggestions",
  dnaMatches:"Matches"
};

const Matches = () => {
  const [activeTab, setActiveTab] = useState("matches");
  const ActiveComponent = tabComponents[activeTab];
 const location = useLocation();

    const setTab = (key)=>{
    sessionStorage.setItem("MatchesTab", key)
    setActiveTab(key);
  }
 useEffect(()=>{
   if(location.state?.activtab){
    setTab(location.state?.activtab || "matches")
    sessionStorage.setItem("MatchesTab",location.state?.activtab)
    }else if(sessionStorage.getItem("MatchesTab")){
      setTab(sessionStorage.getItem("MatchesTab"))
    }else{
      setTab("matches")
    }
 },[location.state?.activtab])
 const [showChatBox, setShowChatBox] = useState(false)
 const [selectedProfile, setSelectedProfile] = useState(null)
 const chatBoxOpen = (profileId) =>{
  setSelectedProfile(profileId)
  setShowChatBox(true)
 }

  return (
    <div>
      <div className="container mt-3">
        <ul className="nav nav-tabs" id="mainTab" role="tablist">
          {Object.keys(tabComponents).map((tabKey) => (
            <li className="nav-item" key={tabKey}>
              <button
                className={`nav-link ${activeTab === tabKey ? "active" : ""}`}
                onClick={() => setTab(tabKey)}
              >
                {tabHeadings[tabKey]}
              </button>
            </li>
          ))}
        </ul>

        <div className="tab-content">
          {ActiveComponent && <ActiveComponent chatBoxOpen={chatBoxOpen}/>}
        </div>
      </div>
      <ChatBox showChatBox={showChatBox} selectedProfile={selectedProfile} setShowChatBox={()=>setShowChatBox(false)}/>
    </div>
  );
};

export default Matches;
